import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import {
  SiteFrame,
  MainWrap,
  HeaderRoot,
  HeaderBar,
  LogoWrap,
  LogoImage,
} from '../components/StyledComponents/Header.styles';
import LogoPng from '../assets/images/Logo.png';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <CssBaseline />
      <SiteFrame>
        <HeaderRoot>
          <HeaderBar maxWidth={false} disableGutters>
            <Grid container alignItems="center" wrap="nowrap">
              <LogoWrap>
                <Link to="/" aria-label="OrderX home">
                  <LogoImage src={LogoPng} alt="OrderX" />
                </Link>
              </LogoWrap>
            </Grid>
          </HeaderBar>
        </HeaderRoot>
        <MainWrap>{children}</MainWrap>
      </SiteFrame>
    </>
  );
}
